export type RateLimitEndpointType = 'default' | 'auth' | 'upload' | 'search';

const DEFAULT_RATE_LIMIT_URL_MARKERS = [
  '/agent/bookings/list',
  '/agent/leads/list',
] as const;

export const classifyRateLimitEndpointType = (url?: string | null): RateLimitEndpointType => {
  if (!url) return 'default';

  const urlPath = url.split('?')[0];

  if (DEFAULT_RATE_LIMIT_URL_MARKERS.some((marker) => urlPath.includes(marker))) {
    return 'default';
  }

  if (
    urlPath.includes('/login') ||
    urlPath.includes('/register') ||
    urlPath.includes('/logout') ||
    urlPath.includes('/api/user/auth/')
  ) {
    return 'auth';
  }

  if (urlPath.includes('/upload') || urlPath.includes('/img')) {
    return 'upload';
  }

  if (urlPath.includes('/search') || urlPath.includes('/list')) {
    return 'search';
  }

  return 'default';
};
